export default __webpack_public_path__ + "static/center-es-bc71df952b3dca7156c646ffd82b9066.webp";